import React from 'react';
import { Box, IconButton, InputBase } from '@mui/material';
import { chatStyles } from '../styles';
import AudioGravador from '../AudioGravador';

interface ChatInputProps {
  input: string;
  setInput: (input: string) => void;
  onSendMessage: () => void;
  onAudioTranscription: (text: string) => void;
  loading: boolean;
}

export const ChatInput: React.FC<ChatInputProps> = ({
  input,
  setInput,
  onSendMessage,
  onAudioTranscription,
  loading
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSendMessage();
    }
  };

  return (
    <Box sx={chatStyles.inputContainer}>
      <InputBase
        fullWidth
        multiline
        minRows={1}
        maxRows={4}
        placeholder="Escreva aqui como posso te ajudar..."
        value={input}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        sx={chatStyles.input}
        disabled={loading}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AudioGravador onTranscricao={onAudioTranscription} disabled={loading} />
        <IconButton
          onClick={onSendMessage}
          sx={chatStyles.sendButton}
          disabled={loading}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/send-gray.svg`}
            alt="Enviar mensagem"
            style={{ width: 42, height: 42 }}
          />
        </IconButton>
      </Box>
    </Box>
  );
};
